import { CopyBlock, dracula } from "react-code-blocks"
import Button from "react-bootstrap/Button"
import Accordion from "react-bootstrap/Accordion"

const soundVariables = `
  music;
  explosionSound;
`

const preloadSnippet = `
    // Add audio
    this.load.audio({
      key: "music",
      url: ["music/game-music.mp3"]
    });

    this.load.audio({
      key: "explosionSound",
      url: ["music/explosion.wav"]
    });
`

const createMusic = `
    this.music = this.sound.add("music");
    this.explosionSound = this.sound.add("explosionSound");

    this.music.play();
`

const hitEnemySnippet = `
    this.explosionSound.play();
`

const musicCont = `
    if (this.music && !this.music.isPlaying) {
      this.music.play();
    }
`

const progressSnippet = `


class MyGame extends Phaser.Scene {
    // Begin our variables 
   cloudsBig;
   cloudsSmall;
   ground;
   hills;
   mountains;
   player;
   cursors;
   playerBullets;
   fireRate = 200;
   nextFireTime = 0;
   enemies;
   enemySpawnRate = 500;
   nextEnemySpawn = 0;
   playerScore = 0;
   playerScoreText;
   playerLives = 3;
   playerLivesText;
   music;
   explosionSound;
   
   // End our variables  
     
   preload() {
     
     this.load.setBaseURL(
       "https://game-course-resources.s3.us-west-2.amazonaws.com"
     );
     // Load background
     this.load.image("clouds-big", "cloudsBig.png");
     this.load.image("clouds-small", "cloudsSmall.png");
     this.load.image("mountains", "Mountains.png");
     this.load.image("hills", "Hills.png");
     this.load.image("ground", "Ground.png");
     this.load.image("bullet", "projectile.png");
     
     // Begin load spritesheets
     this.load.spritesheet("player", "PlayerSpriteSheet.png", {
       frameWidth: 266,
       frameHeight: 122
     });
     
     
    this.load.spritesheet("enemy", "EnemySpriteSheet.png", {
      frameWidth: 266,
      frameHeight: 122
    });
     
     
    this.load.spritesheet("explosion", "explosion.png", {
      frameWidth: 260,
      frameHeight: 260
    });
     // End load spritesheets
     
    // Add audio
    this.load.audio({
      key: "music",
      url: ["music/game-music.mp3"]
    });

    this.load.audio({
      key: "explosionSound",
      url: ["music/explosion.wav"]
    });
     
   }
   
   create() {
     
     this.mountains = this.add.tileSprite(640, 480, 1280, 400, "mountains");
     this.hills = this.add.tileSprite(640, 480, 1280, 400, "hills");
     this.ground = this.add.tileSprite(640, 520, 1280, 400, "ground");
     this.cloudsBig = this.add.tileSprite(640, 200, 1280, 400, "clouds-big");
     this.cloudsSmall = this.add.tileSprite(640, 200, 1280, 400, "clouds-small");
     
     
     // Begin animation section
     var playerAnimConfig = {
       key: "playerAnimation",
       frames: this.anims.generateFrameNumbers("player", {
         start: 0,
         end: 2,
         first: 0
       }),
       frameRate: 10,
       repeat: -1
     };
   
      this.anims.create(playerAnimConfig);
     
     
    // Create Enemy Animation
    var enemyAnimConfig = {
      key: "enemyAnimation",
      frames: this.anims.generateFrameNumbers("enemy", {
        start: 0,
        end: 2,
        first: 0
      }),
      frameRate: 10,
      repeat: -1
    };

    this.anims.create(enemyAnimConfig);

     
    var explosionAnimConfig = {
      key: "explosionAnimation",
      frames: this.anims.generateFrameNumbers("explosion", {
        start: 0,
        end: 5,
        first: 0
      }),
      frameRate: 10,
      repeat: 0
    };

    this.anims.create(explosionAnimConfig);
     // End animation section
   
     // Begin player logic section
           this.player = this.physics.add
       .sprite(250, 250, "player")
       .play("playerAnimation");
           this.player.setScale(0.4);
     this.player.setCollideWorldBounds(true);
     this.cursors = this.input.keyboard.createCursorKeys();
     // End player logic section
     
     
     // Begin groups section
     this.playerBullets = this.physics.add.group();
     this.playerBullets.createMultiple({
       key: "bullet",
       quantity: 20,
       active: false,
       visible: false
     });
     
     
    this.enemies = this.physics.add.group();
    this.enemies.createMultiple({
      key: "enemy",
      quantity: 15,
      active: false,
      visible: false
    });
     
     // End groups section
     
     //Begin Collisions section
    this.physics.add.overlap(
      this.playerBullets,
      this.enemies,
      this.bulletHitEnemy,
      null,
      this
    );
     
     this.physics.add.overlap(
      this.player,
      this.enemies,
      this.playerHitEnemy,
      null,
      this
    );

     //End Collisions section
     
     // Text Section
     this.playerScoreText = this.add.text(500, 5, "Score: " + this.playerScore, { fontFamily: 'Georgia, "Goudy Bookletter 1911", Times, serif', fontSize: "28px" });
     this.playerLivesText = this.add.text(700, 5, "Lives: " + this.playerLives, { fontFamily: 'Georgia, "Goudy Bookletter 1911", Times, serif', fontSize: "28px" });
     // End Text Section
     
     
    this.music = this.sound.add("music");
    this.explosionSound = this.sound.add("explosionSound");

    this.music.play();
     
   }
   
   update(ts, dt) {
     
    if (this.music && !this.music.isPlaying) {
      this.music.play();
    }
     // Begin background logic
     this.cloudsBig.tilePositionX += 0.15;
     this.cloudsSmall.tilePositionX += 0.35;
     this.mountains.tilePositionX += 0.1;
     this.hills.tilePositionX += 0.25;
     this.ground.tilePositionX += 0.45;
     // End backgroun logic
     
     //Begin object cleanup section
     
    this.enemies.children.each((enemy) => {
      if (enemy.x < -50) {
        enemy.disableBody(true, true);
      }
    });

    this.playerBullets.children.each((bullet) => {
      if (bullet.x > 1285) {
        bullet.disableBody(true, true);
      }
    });
     
     //End object cleanup section
     

     
     this.generateEnemy(dt);
     
     // Check player input
     if (this.cursors.left.isDown) {
       this.player.setVelocityX(-160);
     } else if (this.cursors.right.isDown) {
       this.player.setVelocityX(160);
     } else if (this.cursors.up.isDown) {
       this.player.setVelocityY(-160);
     } else if (this.cursors.down.isDown) {
       this.player.setVelocityY(160);
     } else {
       this.player.setVelocityX(0);
       this.player.setVelocityY(0);
     }
     if (this.cursors.space.isDown) {
       this.fire(dt);
     }
   }
     
     //Begin custom functions
     fire(dt) {
       this.nextFireTime -= dt;
       if (this.nextFireTime > 0) {
         return;
       }
       const bullet = this.playerBullets.getFirstDead();
       if (bullet === undefined || bullet == null) {
         return;
       }
   
       bullet.enableBody(true, this.player.x + 50, this.player.y, true, true);
       bullet.setScale(0.3);
       bullet.body.velocity.x += 300;
       setTimeout(() => bullet.disableBody(true, true), 2000);
       this.nextFireTime = this.fireRate;
     }
  
  
  generateEnemy(dt) {
    this.nextEnemySpawn -= dt;
    if (this.nextEnemySpawn > 0) {
      return;
    }
    const enemy = this.enemies.getFirstDead();
    if (enemy === undefined || enemy == null) {
      return;
    }
    
    enemy.enableBody(true, 1300, Phaser.Math.Between(50, 450), true, true);
    enemy.setScale(0.3);
    enemy.body.velocity.x -= Phaser.Math.Between(100, 350);
    enemy.play("enemyAnimation");

    this.nextEnemySpawn = this.enemySpawnRate;
  }
     
  fire(dt) {
    this.nextFireTime -= dt;
    if (this.nextFireTime > 0) {
      return;
    }
    const bullet = this.playerBullets.getFirstDead();
    if (bullet === undefined || bullet == null) {
      return;
    }

    bullet.enableBody(true, this.player.x + 50, this.player.y, true, true);
    bullet.setScale(0.2);
    bullet.body.velocity.x += 300;
    this.nextFireTime = this.fireRate;
  }
  
  
  playerHitEnemy(player, enemy) {
    console.log('boom')
    if (
      enemy.anims.isPlaying &&
      enemy.anims.currentAnim.key === "explosionAnimation"
    ) {
      return;
    }
    if (!enemy.active) {
      return;
    }
    
    this.playerLives--;
    if (this.playerLives <= 0) {
      this.playerScore = 0;
      this.playerLives = 3;
      this.playerScoreText.setText("Score: " + this.playerScore);
    }
      
    this.playerLivesText.setText("Lives: " + this.playerLives);
    
    
    this.explosionSound.play();
    enemy.play("explosionAnimation", false).once("animationcomplete", () => {
      enemy.disableBody(true, true);
      enemy.play("enemyAnimation");
      enemy.x = 1350;
      enemy.y = Phaser.Math.Between(50, 450);
    });
  }
  
    bulletHitEnemy(bullet, enemy) {
    if (
      enemy.anims.isPlaying &&
      enemy.anims.currentAnim.key === "explosionAnimation"
    ) {
      return;
    }
    if (!bullet.active) {
      return;
    }
    bullet.disableBody(true, true);
    bullet.x = -100;
      
    this.playerScore += 100;
    this.playerScoreText.setText("Score: " + this.playerScore);
    this.explosionSound.play();
    enemy.play("explosionAnimation", false).once("animationcomplete", () => {
      enemy.disableBody(true, true);
      enemy.play("enemyAnimation");
      enemy.x = 1350;
      enemy.y = Phaser.Math.Between(50, 450);
    });
  }
  
     //End custom functions, NOTE: None of our code should go below this...
   }
   
   var config = {
   type: Phaser.AUTO,
   width: 1280,
   height: 720,
   backgroundColor: "#5DACD8",
   scene: MyGame,
   physics: {
     default: "arcade",
     arcade: {
       gravity: { y: 0 },
       debug: false
     }
   }
   };
   
   
   var game;
   function startGame() {
   if (!game) {
     game = new Phaser.Game(config);
   } else {
     game.start();
   }
   }
   
   function stopGame() {
   if (game) {
     game.destroy(true, false);
     game = null;
   }
   }
`

const Sound = () => (
  <>
    <h1>A Little Bit of Sound</h1>
    <p>Add these sound variables</p>
    <CopyBlock
      text={soundVariables}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>Add this to preload:</p>
    <CopyBlock
      text={preloadSnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>Add this to create</p>
    <CopyBlock
      text={createMusic}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>Add this inside of hitEnemy function and bullet hit enemy function.</p>
    <CopyBlock
      text={hitEnemySnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />

    <p>Add this to the top of update to loop music</p>
    <CopyBlock
      text={musicCont}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />

    <p>Now we should have a little music</p>

    <br />
    <br />
    <Button type="button" variant="secondary" href="/">
      Next
    </Button>
    <br />
    <br />
    <Accordion flush>
      <Accordion.Item eventKey="0">
        <Accordion.Header>Code Checkpoint</Accordion.Header>
        <Accordion.Body>
          <CopyBlock
            text={progressSnippet}
            language={"js"}
            showLineNumbers={true}
            theme={dracula}
            codeBlock
          />
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
    <br />
    <br />
  </>
)

export default Sound
